import * as api from './api';
import modules from './storeModules';

// mall模块通用接口和方法
export default {
  ...api,
  modules,
};
